import { type List, Record } from "immutable";
import { type IAttributeCondition } from "utils/attributeConditions";

import { type TApprovalAlgorithmRuleDuration } from "../utils/durationsOptions";
import { type TUserRiskLevel } from "../utils/insights";
import { type ApprovalFlowRequestModel, type IApprovalFlowRequestSchema } from "./ApprovalFlowRequestModel";

const defaults = {
  anyOnCallIntegrationSchedules: false,
  approvalFlowId: null as null | string,
  attributeConditions: [] as IAttributeCondition[],
  directoryGroupIds: [] as string[],
  duration: null as TApprovalAlgorithmRuleDuration,
  id: null as null | string,
  onCallIntegrationScheduleIds: [] as string[],
  requests: null as List<ApprovalFlowRequestModel> | null,
  sortOrder: 0,
  userRiskLevels: [] as TUserRiskLevel[],
};

export interface IApprovalAlgorithmRuleSchema {
  anyOnCallIntegrationSchedules: boolean;
  approvalFlowId: null | string;
  attributeConditions: IAttributeCondition[];
  directoryGroupIds: null | string[];
  duration: TApprovalAlgorithmRuleDuration;
  id: null | string;
  onCallIntegrationScheduleIds: null | string[];
  requests: IApprovalFlowRequestSchema[] | null;
  sortOrder: number;
  userRiskLevels: TUserRiskLevel[];
}

export class ApprovalAlgorithmRuleModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const {
      anyOnCallIntegrationSchedules,
      approvalFlowId,
      attributeConditions,
      directoryGroupIds,
      duration,
      id,
      onCallIntegrationScheduleIds,
      requests,
      sortOrder,
      userRiskLevels,
    } = data as typeof defaults;
    return new ApprovalAlgorithmRuleModel({
      anyOnCallIntegrationSchedules,
      approvalFlowId,
      attributeConditions: attributeConditions ?? [],
      directoryGroupIds,
      duration,
      id,
      onCallIntegrationScheduleIds,
      requests,
      sortOrder,
      userRiskLevels: userRiskLevels || [],
    });
  }

  toServerData(): IApprovalAlgorithmRuleSchema {
    const {
      anyOnCallIntegrationSchedules,
      approvalFlowId,
      attributeConditions,
      directoryGroupIds,
      duration,
      id,
      onCallIntegrationScheduleIds,
      requests,
      sortOrder,
      userRiskLevels,
    } = this;
    return {
      anyOnCallIntegrationSchedules,
      approvalFlowId,
      attributeConditions,
      directoryGroupIds: directoryGroupIds || null,
      duration,
      id,
      onCallIntegrationScheduleIds,
      requests: requests ? requests.map((request) => request.toServerData()).toArray() : null,
      sortOrder,
      userRiskLevels,
    };
  }
}
